import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { useTranslation } from "react-i18next";
import withWidth from "@material-ui/core/withWidth/withWidth";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import Typography from "@material-ui/core/Typography/Typography";
import CustomDialog from "../Shared/Components/CustomDialog";
import MainButton from "../Shared/Components/MainButton";
import PropTypes from "prop-types";
import clsx from "clsx";

const useStyles = makeStyles(
  (theme) => ({
    dialogTitleRoot: {
      padding: "12px 12px 20px",
      fontSize: "1.5rem",
      fontWeight: 400,
    },
    dialogContentRoot: {
      padding: "0 24px 24px 12px",
    },
    activeButton: {
      padding: "4px 15px",
      textDecoration: "none",
    },
    TypographyCaption: {
      fontSize: 12,
      lineHeight: 1.7,
    },
  }),
  { name: "SendEmail" }
);

const SendEmail = (props) => {
  const { show, shareUrl, onClose } = props;
  const { t } = useTranslation(["shareEmail", "sendEmail"]);
  const emailUrl = `mailto:?subject=${t("subject")}&body=${t("body")}${window.encodeURIComponent(
    shareUrl
  )})}`;

  const classes = useStyles(props);

  return (
    <CustomDialog
      open={show}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      dialogTitle={t("sendEmail:sendConfiguration")}
      onCancel={onClose}
    >
      <DialogContent className={classes.dialogContentRoot}>
        <Typography
          variant="body1"
          classes={{ root: classes.TypographyCaption }}
          id="alert-dialog-description"
        >
          {t("sendEmail:saveSuccessfully")}
        </Typography>
        <Typography
          variant="body1"
          classes={{ root: classes.TypographyCaption }}
          id="alert-dialog-description"
        >
          {t("sendEmail:softwareNote")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <MainButton
          href={emailUrl}
          onClick={onClose}
          variant="contained"
          className={clsx(classes.activeButton, "primaryButton")}
        >
          {t("sendEmail:sendEmail")}
        </MainButton>
      </DialogActions>
    </CustomDialog>
  );
};

SendEmail.propTypes = {
  onClose: PropTypes.func,
  show: PropTypes.bool,
  shareUrl: PropTypes.string,
};

export default withWidth({ initialWidth: "lg" })(SendEmail);
